"use client";

import { useState, useEffect } from "react";
import Image from "next/image";

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  const menuItems = [
    { label: "O Programa", id: "programa" },
    { label: "O que torna diferente", id: "diferenciais" },
    { label: "Etapas do Programa", id: "etapas" },
    { label: "Benefícios", id: "beneficios" },
    { label: "Requisitos", id: "requisitos" },
  ];

  const editalLink = {
    label: "Edital",
    href: "/Edital-Programa-de-Formacao-de-Devs-nativos-em-IA.pdf",
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-lg py-4" : "bg-transparent py-6"
      }`}
    >
      <div className="container-custom relative">
        <div className="flex justify-between items-center">
          <button
            type="button"
            className="flex items-center cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <Image
              src={
                scrolled
                  ? "/images/formacao-devs-ia/Logo-Agi.svg"
                  : "/images/formacao-devs-ia/Logo-Agi-Branco.svg"
              }
              alt="Agibank"
              width={56}
              height={56}
              className="h-10 md:h-14 w-auto transition-all duration-300"
            />
          </button>

          <div className="hidden xl:flex items-center gap-10">
            <div className="flex gap-6 text-sm font-medium">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className={`transition-colors ${
                    scrolled
                      ? "font-bold text-blue-dark hover:text-blue-main"
                      : "font-bold text-white hover:text-secondary-main"
                  }`}
                >
                  {item.label}
                </button>
              ))}
              <a
                href={editalLink.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`transition-colors ${
                  scrolled
                    ? "font-bold text-blue-dark hover:text-blue-main"
                    : "font-bold text-white hover:text-secondary-main"
                }`}
              >
                {editalLink.label}
              </a>
            </div>
            <a
              href="https://job-boards.greenhouse.io/agibank/jobs/5270544008"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-secondary-main text-blue-dark px-8 py-3 rounded-full font-bold text-sm hover:bg-blue-main hover:text-white transition-all transform hover:scale-105 active:scale-95"
            >
              Inscreva-se
            </a>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
            className={`xl:hidden flex flex-col gap-1.5 p-2 ${
              scrolled ? "text-blue-dark" : "text-white"
            }`}
          >
            <span
              className={`w-6 h-0.5 bg-current transition-all ${
                menuOpen ? "rotate-45 translate-y-2" : ""
              }`}
            />
            <span
              className={`w-6 h-0.5 bg-current transition-all ${
                menuOpen ? "opacity-0" : ""
              }`}
            />
            <span
              className={`w-6 h-0.5 bg-current transition-all ${
                menuOpen ? "-rotate-45 -translate-y-2" : ""
              }`}
            />
          </button>
        </div>

        <div
          className={`xl:hidden absolute top-full left-0 w-full bg-white shadow-xl transition-all duration-300 overflow-hidden flex flex-col items-center ${
            menuOpen ? "max-h-[400px] py-6" : "max-h-0 py-0"
          }`}
        >
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-blue-dark hover:text-blue-main font-medium w-full text-center py-3"
            >
              {item.label}
            </button>
          ))}
          <a
            href={editalLink.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-dark hover:text-blue-main font-medium w-full text-center py-3"
          >
            {editalLink.label}
          </a>
          <a
            href="https://job-boards.greenhouse.io/agibank/jobs/5270544008"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-secondary-main text-blue-dark px-8 py-3 rounded-full font-bold text-sm mt-4"
          >
            Inscreva-se
          </a>
        </div>
      </div>
    </nav>
  );
}
